var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-item-header',{staticClass:"pc-note__catalog-header",attrs:{"name":_vm.name,"canFold":_vm.canFold}},[_vm._v(" 笔记本目录 ")])}
var staticRenderFns = []

export { render, staticRenderFns }